import Component from '../lib/Component'

export default class Modal extends Component {
  constructor (elem, APP) {
    super(elem, APP)
    this.wrapper = this.elem.parentNode
    this.isOpen = false
    this.closeTrigger = this.elem.querySelector('.js-close')
    let returnPath = this.elem.getAttribute('data-return-path')
    this.returnPath = returnPath || window.location.href
  }

  openModal () {
    this.addClass('_scroll_locked', document.documentElement)

    this.addAnimationClass('_is_shown', this.wrapper)
      .then(() => {
        this.addAnimationClass('_is_shown')
          .then(() => {
            this.isOpen = true
          })
      })
  }

  closeModal () {
    this.removeClass('_is_shown')
    this.addAnimationClass('_is_hidden')
      .then(() => {
        this.removeClass('_is_shown', this.wrapper)
        this.addAnimationClass('_is_hidden', this.wrapper)
          .then(() => {
            this.isOpen = false
            this.removeClass('_is_hidden')
            this.removeClass('_is_hidden', this.wrapper)
            this.removeClass('_scroll_locked', document.documentElement)
            this.wrapper.innerHTML = ''
            window.history.pushState({}, '', this.returnPath)
          })
      })
  }

  init () {
    let self = this
    document.addEventListener('keyup', function (e) {
      if (self.isOpen && e.keyCode === 27) {
        self.closeModal()
      }
    })

    this.wrapper.addEventListener('click', function (e) {
      if (self.isOpen && e.target === this) {
        self.closeModal()
      }
    })

    this.closeTrigger.addEventListener('click', () => this.closeModal())
    this.APP.events.subscribe('Modal:openModal', this.openModal.bind(this))
    this.APP.events.subscribe('Modal:closeModal', this.closeModal.bind(this))
    let action = this.elem.getAttribute('data-action')
    if (action === 'openModal') {
      this.APP.events.publish('Modal:openModal')
    }
  }
}
